module.exports = __webpack_public_path__ + "img/back_1000.5bce21a5.jpg";